import React from 'react';
import MasterSidebar from './MasterSidebar';
import logo from '../images/KrossKast_Logo-red.png';
import AuthenticatedUserMenu from './AuthenticatedUserMenu';

const MasterLayout = ({ children }) => {
  return (
    <div className="master-account-page">
      <div className="top-nav">
        <img src={logo} alt="KrossKast" className="nav-logo" />
        <AuthenticatedUserMenu />
      </div>
      <div className="master-content">
        <MasterSidebar />
        <div className="main-area">{children}</div>
      </div>
    </div>
  );
};

export default MasterLayout;
